import { render, staticRenderFns } from "./SurveyTestmodeConfirmModal.vue?vue&type=template&id=25761547"
import script from "./SurveyTestmodeConfirmModal.vue?vue&type=script&lang=js"
export * from "./SurveyTestmodeConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports